import { SET_MEMBER_DIECTORY, SET_RESOURCE_COLLECTIONS } from './types'

const initialState = {
  directoryMembers: [],
  resources: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_RESOURCE_COLLECTIONS:
      return {
        ...state,
        resources: action.payload,
      }
    case SET_MEMBER_DIECTORY:
      return {
        ...state,
        directoryMembers: action.payload,
      }
    default:
      return state
  }
}
